import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './components/pages/login/login.component';
import { DashboardComponent } from './components/pages/dashboard/dashboard.component';
import { DashboardAdminComponent } from './components/pages/dashboard/admin/dashboard-admin.component';
import { DashboardGroupedByDateComponent } from './components/pages/dashboard/groupedbydate/dashboard-groupedbydate.component';
import { DashboardChurnComponent } from './components/pages/dashboard/churn/dashboard-churn.component';
import { DashboardSubscriptionComponent } from './components/pages/dashboard/subscription/dashboard-subscription.component';
import {
  DashboardSubscriptionCountComponent
} from './components/pages/dashboard/subscription-count/dashboard-subscription-count.component';
import { DashboardOptionComponent } from './components/pages/dashboard/option/dashboard-option.component';
import { DashboardMiscComponent } from './components/pages/dashboard/misc/dashboard-misc.component';
import { DashboardSponsoringComponent } from './components/pages/dashboard/sponsoring/dashboard-sponsoring.component';
import { AuthGuard } from './auth-guard.service';
import { OtaDetailComponent } from './components/pages/ota/ota-detail.component';
import { TrackerListComponent } from './components/pages/tracker/tracker-list.component';
import { TrackerB2bListComponent } from './components/pages/tracker/tracker-b2b-list.component';
import { TrackerDetailComponent } from './components/pages/tracker/tracker-detail.component';
import { TrackeradminListComponent } from './components/pages/trackeradmin/trackeradmin-list.component';
import { TrackeradminDetailComponent } from './components/pages/trackeradmin/trackeradmin-detail.component';
import { RefuelSmsListComponent } from './components/pages/refuelsms/refuelsms-list.component';
import { TrackerStatusListComponent } from './components/pages/trackerstatus/trackerstatus-list.component';
import { UserDetailComponent } from './components/pages/user/user-detail.component';
import { UserListComponent } from './components/pages/user/user-list.component';
import { UseradminListComponent } from './components/pages/useradmin/useradmin-list.component';
import { SubscriptionDetailComponent } from './components/pages/subscription/subscription-detail.component';
import { SubscriptionListComponent } from './components/pages/subscription/subscription-list.component';
import { TaskDetailComponent } from './components/pages/task/task-detail.component';
import { TaskListComponent } from './components/pages/task/task-list.component';
import { AlertListComponent } from './components/pages/alert/alert-list.component';
import { PositionListComponent } from './components/pages/position/position-list.component';
import {
  DashboardOptionGroupedByDateComponent
} from './components/pages/dashboard/optiongroupedbydate/dashboard-optiongroupedbydate.component';

const appRoutes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'admin', component: DashboardAdminComponent },
      { path: 'grouped-by-date', component: DashboardGroupedByDateComponent },
      { path: 'churn', component: DashboardChurnComponent },
      { path: 'subscription-total', component: DashboardSubscriptionComponent },
      { path: 'subscription-count', component: DashboardSubscriptionCountComponent },
      { path: 'option', component: DashboardOptionComponent },
      { path: 'optgroupedbydate', component: DashboardOptionGroupedByDateComponent },
      { path: 'misc', component: DashboardMiscComponent },
      { path: 'sponsoring', component: DashboardSponsoringComponent },
    ]
  },
  { path: 'ota', component: OtaDetailComponent, canActivate: [AuthGuard] },
  {
    path: 'tracker',
    canActivate: [AuthGuard],
    children: [
      { path: ':id/position', component: PositionListComponent },
      { path: ':id/alert', component: AlertListComponent },
      { path: ':id', component: TrackerDetailComponent },
      { path: '', component: TrackerListComponent }
    ]
  },
  { path: 'b2b-trackers', component: TrackerB2bListComponent, canActivate: [AuthGuard] },
  {
    path: 'trackeradmin',
    canActivate: [AuthGuard],
    children: [
      { path: ':id', component: TrackeradminDetailComponent },
      { path: '', component: TrackeradminListComponent }
    ]
  },
  { path: 'refuelsms', component: RefuelSmsListComponent, canActivate: [AuthGuard] },
  { path: 'trackerstatus', component: TrackerStatusListComponent, canActivate: [AuthGuard] },
  {
    path: 'user',
    canActivate: [AuthGuard],
    children: [
      { path: ':id', component: UserDetailComponent },
      { path: '', component: UserListComponent }
    ]
  },
  {
    path: 'useradmin',
    canActivate: [AuthGuard],
    children: [
      { path: ':id', component: UserDetailComponent },
      { path: '', component: UseradminListComponent }
    ]
  },
  {
    path: 'subscription',
    canActivate: [AuthGuard],
    children: [
      { path: ':id', component: SubscriptionDetailComponent },
      { path: '', component: SubscriptionListComponent }
    ]
  },
  {
    path: 'task',
    canActivate: [AuthGuard],
    children: [
      { path: ':id', component: TaskDetailComponent },
      { path: '', component: TaskListComponent }
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
//  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {enableTracing: false} // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/app-routing.module.ts